// **********************************************************
// Explore Module
// **********************************************************

const exploreSlider = document.querySelectorAll('[data-slider="explore-slider"]');

const exploreSliderOptions = {
  slidesPerView: 1,
  speed: 1000,
  watchOverflow: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  effect: 'coverflow',
  coverflowEffect: {
    rotate: 0,
    scale: 0.96,
    stretch: 0,
    depth: 0,
    modifier: 1,
    slideShadows: false,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1023: {
      coverflowEffect: {
        depth: 90,
        scale: 0.88,
      },
    },
    1299: {
      coverflowEffect: {
        depth: 80,
        scale: 0.88,
      },
    },
    1440: {
      coverflowEffect: {
        depth: 54,
        scale: 0.88,
      },
    },
  },
};

exploreSlider.forEach((el) => {
  const parentElem = el.closest('.explore-module');
  const paginationElement = parentElem.querySelector('.swiper-pagination');

  const arrowRight = parentElem.querySelector('.next-button');
  const arrowLeft = parentElem.querySelector('.prev-button');

  exploreSliderOptions.navigation.nextEl = arrowRight;
  exploreSliderOptions.navigation.prevEl = arrowLeft;

  exploreSliderOptions.pagination.el = paginationElement;

  new Swiper(el, exploreSliderOptions);
});
